import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    chip: {
      marginRight: 5,
      backgroundColor: "rgb(233, 229, 226)",
      "&:active, &:focus, &:hover": {
        backgroundColor: "rgba(233, 229, 226, 0.9)"
      }
    },
    chipActive: {
      marginRight: 5,
      backgroundColor: "rgb(48, 63, 159)",
      color: "#fff",
      "&:active, &:focus, &:hover": {
        backgroundColor: "rgba(48, 63, 159, 0.9)"
      }
    }
  })
);
